import request from 'superagent';
import { Observable } from 'rxjs/Observable';
import { TOGGLE_CHAT_PANEL_OPEN, LOAD_BRAND_TEXT, LOAD_BRAND_TEXT_SUCCESS } from './actions';

const updateIframeOpenStateEpic = action$ =>
  action$.ofType(TOGGLE_CHAT_PANEL_OPEN).flatMap(() => {
    window.parent.postMessage(
      {
        source: 'ambitChatLauncher',
        type: 'toggleWebChatOpenState'
      },
      '*'
    );

    return Observable.empty();
  });

const loadBrandTextEpic = (action$, store) =>
  action$.ofType(LOAD_BRAND_TEXT).flatMap(() => {
    request.get(`${store.config.botBaseUrl}/public/brand`).end((err, res) => {
      if (err || !res.body || Object.keys(res.body).length === 0) {
        return Observable.empty();
      }

      return store.dispatch({
        type: LOAD_BRAND_TEXT_SUCCESS,
        payload: { brandText: res.body.brand, brandLink: res.body.brandLink }
      });
    });

    return Observable.empty();
  });

export const epics = [updateIframeOpenStateEpic, loadBrandTextEpic];



// WEBPACK FOOTER //
// ./src/reducers/ui/epics.js